import { Chart, SkillChart } from "../../actionTypes";

const initialState = {
  skillsChartList: [],
  chartList: {},
  contextList: {},
  SkillChartDetails: [],
  skillsContextList: {},
};

const SkillsChartReducer = (state = initialState, action) => {
  switch (action.type) {
    case Chart.CREATE_CHART_SUCCESS:
      const chartCreateData = action.data
        ? { chartData: { ...action.data } }
        : null;
      return {
        ...state,
        ...chartCreateData,
        isLoading: action.isLoading,
      };

    case SkillChart.SKILL_CHART_DETAILS:
      const SkillChartDetails = action.data
        ? { skillChartDetails: { ...action.data } }
        : null;
      return {
        ...state,
        ...SkillChartDetails,
        isLoading: action.isLoading,
      };

    //CHART DASHBOARD
    case SkillChart.SKILL_CHART_LIST:
      const isData = action.data
        ? { skillsChartList: { ...action.data } }
        : null;
      return {
        ...state,
        ...isData,
        isLoading: action.isLoading,
      };

    case Chart.CHART_UPDATE_STATUS:
      let updateStatus = null;
      if (action?.typeOfChart === "") {
        const updatedData = action.data
          ? state.chartList?.rows?.map((x) =>
              x.ID === action.data?.ID
                ? { ...x, Status: action.data?.Status }
                : x
            )
          : null;
        updateStatus = updatedData
          ? { chartList: { ...state.chartList, rows: updatedData } }
          : null;
      } else {
        const updatedData = action.data
          ? state.chartList?.rows?.filter((x) => x.ID !== action.data?.ID)
          : null;
        updateStatus = updatedData
          ? { chartList: { ...state.chartList, rows: updatedData } }
          : null;
      }
      return {
        ...state,
        ...updateStatus,
        isLoading: action.isLoading,
      };

    case Chart.CREATE_CONTEXT:
      const createContext = action.data
        ? {
            contextList: {
              ...state.contextList,
              rows: [...state.contextList?.rows, action.data],
            },
          }
        : null;
      return {
        ...state,
        ...createContext,
        isContextLoading: action.isLoading,
      };
    case SkillChart.SKILL_CONTEXT_LIST:
      const contextData = action.data
        ? { skillsContextList: { ...action.data } }
        : null;
      return {
        ...state,
        ...contextData,
        isContextLoading: action.isLoading,
      };

    case Chart.CONTEXT_LIST_DELETE:
      const deleteData = action.data
        ? state.contextList?.rows?.filter((item) => item.ID !== action.data?.ID)
        : null;
      const contextDeleteList = deleteData
        ? { contextList: { ...state.contextList, rows: deleteData } }
        : null;

      return {
        ...state,
        ...contextDeleteList,
        isContextLoading: action.isLoading,
      };

    default:
      return state;
  }
};
export default SkillsChartReducer;
